import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core'
import { AuthService, MatrixServices, RestServices, SharedServices, StateServices } from '../../services'
import { ActivatedRoute, Router } from '@angular/router'
import { onsNotification } from 'ngx-onsenui'
import { CookieService } from 'ngx-cookie-service'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { PaymentHelper, versionWeb } from '../../../helper'
import * as moment from 'moment'
import { ConfigService } from '@services/config.service'

@Component({
    selector: 'app-top',
    templateUrl: './top.component.html',
    styleUrls: ['../../stagingcss/main-body.component.css', '../../stagingcss/lui-select.component.css', './top.component.css'],
})
export class TopComponent implements OnInit, OnDestroy {
    versionWeb = versionWeb
    allowExperimentalFeatures = localStorage.getItem('ngStorage_allowExperimentalFeatures')
    auth: any
    lockAccount: boolean = false
    paymentError: boolean = false
    paymentErrorMsg: string = ''
    timeout: any
    hiddenModal = 'hidden'
    hiddenModalCommunication = 'hidden'
    groupMenu = ''
    showOption: any
    filterLang: string
    // check language default show modal
    langDefault = localStorage.getItem('lang') === 'false' ? 'false' : 'true'
    optionArr = [{ id: 1, name: 'English', lang: 'true' }, { id: 2, name: '日本語', lang: 'false' }]

    optionArrCopy = this.optionArr.slice() // copy of optionArr
    styleVisibility: any
    ModalInnit = 'hidden'
    formInnit: FormGroup
    percentage = 0
    strongText = 'Very Weak'
    strongClass = 'veryWeak'
    validName = true
    validNameText = 'innit-input-requied'
    validTimeZone = false
    sumited = false
    formValid = true
    ModalTimezone = 'hidden'
    offsetTmz = []
    filterTimezone
    showOptionTimezone: any
    offsetTmzCopy
    defaultTimeZone
    en: any = {}
    showEN = true
    tokenRegis = 'no-token'
    urlLogo = 'assets/img/logo.png'
    enableBehavior: any = 'false'
    form_error_password_valid =''
    isPasssWordValid = true

    constructor(private authData: AuthService,
                private router: Router,
                private stateServices: StateServices,
                private checkApi: RestServices,
                private _sharedService: SharedServices,
                private cookieService: CookieService,
                private route: ActivatedRoute,
                private formBuilder: FormBuilder,
                private restApi: RestServices,
                public matrixServices: MatrixServices,
                private _renderer2: Renderer2,
                private configService: ConfigService,
    ) {
        const activeTheme = localStorage.getItem('classThemeBody')
        this.ckLogoTop(activeTheme)
        let urlParam = this.route.url['value']
        if (urlParam.length == 2 && urlParam[0].path == 'registration') {
        
        } else {
            this.getCommon()
        }
    }

    ngOnInit() {
        // localStorage.setItem('enableBehavior', 'true');
        const user = this.authData.getUser();
        if(user){
            this.allowExperimentalFeatures = user['allowExperimental'];
        }
        if (this.langDefault) {
            this.styleVisibility = { visibility: 'visible' }
        }
        this.formInnit = this.formBuilder.group({
            name: ['', [Validators.required]],
            administratorPassword: ['', [Validators.required]],
            organizationName: ['', [Validators.required]],
            state: '',
            city: '',
            address: '',
            phone: '',
            contactPerson: '',
            clinicName: '',
            familyName: ['', [Validators.required]],
        })
        let urlParam = this.route.url['value']
        if (urlParam.length == 2 && urlParam[0].path == 'registration') {
            this.tokenRegis = urlParam[1].path
            this.registrationLogin()
        } else {
            // const user = this.authData.getUser()
            this.auth = user

            this.lockAccount = this.auth.availability == 'Off'
        }
        this.changeLanguage()

        this.stateServices.emitChangeArrImageHash(null)
        this.stateServices.resetAllSearchTabIds()
        this.stateServices.emitChangeIsShowTableSelect(undefined)
        this.stateServices.emitChangeDefaultArrSelect(undefined)
        this.configService.load()
    }

    getCommon() {
        // set class display theme
        if(localStorage.getItem('classThemeBody')) {
            jQuery('body').attr('class', localStorage.getItem('classThemeBody'))
        }
        const resourceUrl = 'resource'
        const resourceData = {
            actions: [], status: {
                setting: {
                    map: {
                        common: true,
                    },
                },
            },
        }
        this.authData.authToken().then(tokenReNew => {
            this.checkApi.http_post(resourceUrl, resourceData, tokenReNew).subscribe(success => {
                const commonSetting = success['response']['setting']['map']['common']
                const themeStatus = commonSetting['chooseTheme'] || 'blue'
                if (themeStatus != localStorage.getItem('classThemeBody')) {
                    jQuery('body').attr('class', themeStatus)
                    localStorage.setItem('classThemeBody', themeStatus)
                }
                this.ckLogoTop(themeStatus)
                const user = success['user']
                this.enableBehavior = this.stateServices.checkEnableSettingBehaviour(user['_id'])
                const emitSakura = {}
                emitSakura['enableBehavior'] = this.enableBehavior
                this.stateServices.emitChangeEnableBehavior(emitSakura)
                if (PaymentHelper.checkNeedPaymentInfo(user, commonSetting)) {
                    this.router.navigateByUrl('/app/main/setting/common')
                }
                this.showMessageOrRedirect()

            })
        })
    }

    ckLogoTop(themeStatus) {
        if (themeStatus === 'blue') {
            this.urlLogo = 'assets/img/logo.png'
            localStorage.setItem('urlLogo', this.urlLogo)
        } else if (themeStatus === 'green') {
            this.urlLogo = 'assets/img/logo1.png'
            localStorage.setItem('urlLogo', this.urlLogo)
        } else if (themeStatus === 'red') {
            this.urlLogo = 'assets/img/logo2.png'
            localStorage.setItem('urlLogo', this.urlLogo)
        } else if (themeStatus === 'lemon') {
            this.urlLogo = 'assets/img/logo3.png'
            localStorage.setItem('urlLogo', this.urlLogo)
        } else if (themeStatus === 'origin') {
            this.urlLogo = 'assets/img/logo4.png'
            localStorage.setItem('urlLogo', this.urlLogo)
        } else if (themeStatus === 'violet') {
            this.urlLogo = 'assets/img/logo5.png'
            localStorage.setItem('urlLogo', this.urlLogo)
        } else if (themeStatus === 'black') {
            this.urlLogo = 'assets/img/logo6.png'
            localStorage.setItem('urlLogo', this.urlLogo)
        }
    }

    showMessageOrRedirect() {
        this.paymentError = false
        const user = this.authData.getUser()
        if (this.lockAccount) {
            this.paymentError = true
            if (moment(new Date()).add(1, 'month') > moment(new Date(user.deleteDate))) {
                this.paymentErrorMsg = this.en.payment.messages.account_maybe_delete
            } else {
                this.paymentErrorMsg = this.en.payment.messages.payment_failure
            }
        } else if (!user.gmoCardFlg && !PaymentHelper.isTrialTime(user)) {
            this.paymentError = true
            this.paymentErrorMsg = this.en.payment.messages.payment_card_not_register
        }
    }

    ngOnDestroy() {
        // Clean subscriptions, intervals, etc
        this.matrixServices.resetMatrix()

    }

    // logout user
    logout() {
        if (this.authData.getItem('user')) {
            localStorage.removeItem('user')
            localStorage.removeItem('token')
            localStorage.removeItem('timeout')
            this.cookieService.delete('token')
            jQuery('body').attr('class', 'blue')
            localStorage.removeItem('urlLogo')
            localStorage.removeItem('classThemeBody')
            return this.router.navigateByUrl('/app/login')
        }
    }

    routerCommunication() {
        this.router.navigateByUrl('/app/main/communication')
    }

    // show modal language
    selectLanguage() {
        this.hiddenModal = 'active'

    }

    // show communication
    showModalallowExperimentalFeatures() {
        this.hiddenModalCommunication = 'active'
    }

    // hiden modal
    hidenModal() {
        this.hiddenModal = 'hidden'
        this.hiddenModalCommunication = 'hidden'
    }

    selectOption(id, lang) {
        this.showOption = 'showOption_' + id
        if (this.showOption || this.langDefault === lang) {
            this.authData.authToken().then(tokenReNew => {
                this.restApi.http_post('account/lang', { lang: id == 1 ? 'en' : 'ja' }, tokenReNew).subscribe(res => {
                    if(res['success']){
                        this.styleVisibility = { visibility: 'visible' }
                        localStorage.setItem('lang', lang)
                        this.langDefault = lang
                        this.changeLanguage()
                        this.showMessageOrRedirect()
                    }
                })
            })
            this.hidenModal()
        }
        this.showMessageOrRedirect()

    }

    // search language
    search(): void {
        const term = this.filterLang
        this.optionArr = this.optionArrCopy.filter(function(tag) {
            return tag.name.indexOf(term) >= 0
        })
    }

    menuGroupName(groupMenu) {
        this._sharedService.checkListMenulefft(groupMenu)
    }

    changeLanguage() {
        return this.en = this.authData.showLang(this.showEN)
    }

    registrationLogin() {
        let resourceUrl = 'account/login'
        let resourceData = { registrationToken: this.tokenRegis }
        this.restApi.http_post(resourceUrl, resourceData).subscribe(res => {
            if (res['responseCode'] == 'IncorrectUserIdOrPassword') {
                this.router.navigateByUrl('/app/login')
            } else {
                onsNotification.alert(' Please initialize OrthoComm. ', {
                    title: '<b>Inital setting</b>', callback: i => {
                        if (i === 0) {

                            this.ModalInnit = 'active'
                            this.getTimeZone()
                        }
                    },
                })
            }
        }, err => {
            this.router.navigateByUrl('/app/login')
        })
    }

    preSubmit() {
        this.form_error_password_valid = this.en['form-error-required']

        if ((this.formInnit.get('name').valid && this.formInnit.value.name.length < 6) || (!this.formInnit.get('name').valid && this.sumited)) {
            this.validName = false
            if (this.formInnit.get('name').valid && this.formInnit.value.name.length < 6) {
                this.validNameText = 'innit-account-account-too-short'
            }
            this.checkFormValid()
        } else if (this.formInnit.value.name.length >= 6) {
            let resourceUrl = 'account/accountExists'
            let resourceData = { organizationId: this.formInnit.value.name }
            //
            this.restApi.http_post(resourceUrl, resourceData).subscribe(res => {
                //
                if (res['accountExists']) {
                    this.validName = false
                    this.validNameText = 'innit-account-exis'
                } else {
                    this.validName = true
                    this.validNameText = 'innit-account-can-use'
                    if (this.formInnit.value.name.search(/(^[A-Za-z0-9\.\-\_]+$)/) === -1) {
                        this.validNameText = 'innit-input-pattern'
                        this.validName = false
                    }
                }
                this.checkFormValid()
            })
        } else {
            this.validName = true
            this.validNameText = 'innit-input-requied'
            this.checkFormValid()
        }
        
        if(this.formInnit.get('administratorPassword').value && this.formInnit.get('administratorPassword').value.trim()!=''){
            const reg = new RegExp(/^[ -00-9:-@A-~]*$/)
            if(!this.formInnit.value.administratorPassword.match(reg)){
                this.formValid = false
                this.isPasssWordValid = false
                this.form_error_password_valid =this.en['form-error-password-valid']
            } else {
                this.isPasssWordValid = true
            }
        } else {
            this.formValid = false
            this.isPasssWordValid = false
        }

    }

    checkFormValid() {
        if (this.formInnit.valid && this.validName && this.validTimeZone && this.isPasssWordValid) {
            this.formValid = true
        } else {
            if (this.sumited) {
                this.formValid = false
            }
        }
    }

    checkStrongPassword() {
        let val = this.formInnit.value.administratorPassword.trim()
        if (val.length < 3) {
            this.percentage = val.length * 10
            this.strongText = 'innit-password-strong-level-very-weak'
            this.strongClass = 'veryWeak'
        } else if (val.length > 2 && val.length < 10) {
            this.percentage = val.length * 10
            this.strongText = 'innit-password-strong-level-weak'
            this.strongClass = 'weak'
        } else if (val.length > 9 && val.length < 15) {
            this.percentage = 100
            this.strongText = 'innit-password-strong-level-strong'
            this.strongClass = 'strong'
        } else {
            this.percentage = 100
            this.strongText = 'innit-password-strong-level-very-strong'
            this.strongClass = 'veryStrong'
        }
        if(val){
            const reg = new RegExp(/^[ -00-9:-@A-~]*$/)
            if(!this.formInnit.value.administratorPassword.match(reg)){
                this.formValid = false
                this.isPasssWordValid = false
                this.form_error_password_valid =this.en['form-error-password-valid']
            } else {
                this.form_error_password_valid = this.en['form-error-required']
                this.isPasssWordValid = true
            }
        }

    }

    openModalTimezone() {
        this.ModalTimezone = 'active'
    }

    // hidden modal time zone
    hidenModalTimeZone() {
        this.ModalTimezone = 'hidden'
    }

    // get list time zone
    getTimeZone() {
        const moment = require('moment-timezone')
        const timeZones = moment.tz.names()
        const addTimeZone = []
        for (const i in timeZones) {
            addTimeZone.push(timeZones[i]) // + ' (' + moment.tz(timeZones[i]).format('z') + ')'
        }
        this.offsetTmz = addTimeZone
        this.offsetTmzCopy = this.offsetTmz.slice()
    }

    // search time zone
    searchTimeZone(): void {
        const term = this.filterTimezone
        this.offsetTmz = this.offsetTmzCopy.filter(function(tag) {
            return tag.indexOf(term) >= 0
        })
    }

    selectOptionTimeZone(id) {
        this.showOptionTimezone = 'showOption_' + id
        this.defaultTimeZone = id
        if (this.showOptionTimezone) {
            this.styleVisibility = { visibility: 'visible' }
            this.hidenModalTimeZone()
            this.validTimeZone = true
            this.preSubmit()
            this.filterTimezone = null
        }
    }

    submitFormInnit() {
        this.sumited = true
        this.validName = this.formInnit.get('name').valid
        this.preSubmit()
        setTimeout(() => {
            if (this.formValid) {
                const resourceUrl = 'account/login'
                const resourceData = {
                    initialization: {
                        registrationToken: this.tokenRegis, account: {
                            name: this.formInnit.get('name').value.trim(),
                            administratorPassword: this.formInnit.get('administratorPassword').value.trim(),
                        }, doctor: {
                            familyName: this.formInnit.get('familyName').value.trim(),
                        }, commonSetting: {
                            timezone: this.defaultTimeZone,
                            state: this.formInnit.get('state').value,
                            city: this.formInnit.get('city').value,
                            address: this.formInnit.get('address').value,
                            phone: this.formInnit.get('phone').value,
                            contactPerson: this.formInnit.get('contactPerson').value,
                            clinicName: this.formInnit.get('clinicName').value,
                        },
                    },
                }

                this.restApi.http_post(resourceUrl, resourceData).subscribe(success => {
                    this.authData.setItem('user', success)
                    this.authData.setItem('token', success['token'])
                    this.authData.setItem('timeout', Date.now())
                    this.cookieService.set('token', success['token'], 1)
                    this.router.navigateByUrl('/app/top')
                }, err => {
                    this.router.navigateByUrl('/app/login')
                })
            }
        }, 200)

    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/top/top.component.ts